import { useEffect, useRef, useState } from 'react';
import { useFormik, Formik } from 'formik';
import * as Yup from 'yup';
import { GLOBAL_CONSTANTS, ROUTES, S3DataGetApi, TOASTER_CONFIGS } from '../../constants';
import { Button, TextField, Box, Grid, Typography, InputAdornment, IconButton } from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useDepartmentCreateMutation, useDepartmentGetOneQuery, useDepartmentUpdateMutation } from '../../service/apiSlices/accessApiService';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';


const CreateDepartment = () => {

    const navigate = useNavigate();
    const { id } = useParams();
    const { data: getData } = useDepartmentGetOneQuery(id);
    const [profilePicture, setProfilePicture] = useState('');
    const [initialValues, setInitialValues] = useState({
        name: '',
        category_icon: '',
    });
    const [createApiCall] = useDepartmentCreateMutation();
    const [updateApiCall] = useDepartmentUpdateMutation();

    const fileInputRef: any = useRef(null);
    const [fileName, setFileName] = useState('');

    const handleIconClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    useEffect(() => {
        var Response = getData?.result?.data[0]
        if (getData?.result?.data) {
            setInitialValues({
                name: Response?.name,
                category_icon: Response?.category_icon,
            })
            setProfilePicture(Response?.category_icon)
        }
    }, [getData])

    const validationSchema = Yup.object({
        name: Yup.string()
            .max(50, 'Must be 50 characters or less')
            .required('Required'),
        category_icon: Yup.string().required('Required')
    });

    const handleApicall = (values: any) => {

        if (id && getData) {
            var updatePayload = {
                name: values.name,
                category_icon: profilePicture,
                id: id
            }
            updateApiCall(updatePayload)
                .unwrap()
                .then((response) => {
                    toast.success(response?.message, TOASTER_CONFIGS);
                    navigate(ROUTES.MANAGEDEPARTMENT);
                })
                .catch((error) => {
                    toast.error(error?.data?.message, TOASTER_CONFIGS);
                })
        } else {

            var createPayload = {
                name: values.name,
                category_icon: profilePicture,
            }
            createApiCall(createPayload)
                .unwrap()
                .then((response) => {
                    toast.success(response?.message, TOASTER_CONFIGS);
                    navigate(ROUTES.MANAGEDEPARTMENT);
                })
                .catch((error) => {
                    toast.error(error?.data?.message, TOASTER_CONFIGS);
                })
        }


    };

    /**Handle profile change */
    const handleChange = async (event: any) => {
        // if (event.target.files[0].type.split("/")[0] === "image") {
        try {
            const uploadedImage: any = await S3DataGetApi(event);
            setProfilePicture(uploadedImage);
        } catch (error) {
        }
        // } else {
        //     toast.error('Please choose file Image format', TOASTER_CONFIGS);
        // }
    };


    return (
        <>

            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values, actions) => {
                    handleApicall(values);
                }}
                enableReinitialize={true}
            >
                {(formik) => (
                    <Box
                        component="form"
                        sx={{ '& .MuiTextField-root': { m: 1, width: '100%' } }}
                        noValidate
                        autoComplete="off"
                        onSubmit={formik.handleSubmit}
                    >
                        <Grid container spacing={2} justifyContent="flex-start" alignContent='center' marginTop={1} marginBottom={3}
                            sx={{ cursor: 'pointer' }} onClick={() => navigate(-1)}>
                            <KeyboardArrowLeftIcon />
                            <Typography>
                                {id ? 'Edit' : 'Add'} Category
                            </Typography>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    id="outlined-controlled"
                                    label="Name"
                                    name="name"
                                    value={formik.values.name}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.name && Boolean(formik.errors.name)}
                                    helperText={formik.touched.name && formik.errors.name}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <input
                                    type="file"
                                    id="outlined-controlled"
                                    name="category_icon"
                                    style={{ display: 'none' }}  // Hides the file input
                                    ref={fileInputRef}
                                    onChange={(e: any) => {
                                        const file = e.target.files[0];
                                        if (file) {
                                            setFileName(file.name);
                                            formik.handleChange(e);
                                            handleChange(e);
                                        }
                                    }}
                                    onBlur={formik.handleBlur}
                                />

                                {/* Visible Input Field with Upload Icon */}
                                <TextField
                                    id="displayed-file-input"
                                    placeholder="Choose Icon"
                                    value={fileName}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton edge="end" onClick={handleIconClick}>
                                                    <CloudUploadIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                        readOnly: true, // Makes the TextField read-only
                                    }}
                                    error={formik.touched.category_icon && Boolean(formik.errors.category_icon)}
                                    helperText={formik.touched.category_icon && formik.errors.category_icon}
                                    onClick={handleIconClick} // Trigger file input when clicking the input field
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                {profilePicture && (
                                    <img src={profilePicture} style={{
                                        width: '70px',
                                        height: '70px',
                                        borderRadius: '50%',
                                        objectFit: 'cover'
                                    }} />
                                )}
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} justifyContent="flex-end">
                            <Grid item>
                                <Button
                                    type="button"
                                    variant="contained"
                                    color="inherit"
                                    onClick={() => {
                                        if (id) {
                                            var Response = getData?.result?.data[0]
                                            if (getData?.result?.data) {
                                                setInitialValues({
                                                    name: Response?.name,
                                                    category_icon: Response?.category_icon,
                                                })
                                                formik.values.name = Response?.name;
                                                formik.values.category_icon = Response?.category_icon;
                                                setProfilePicture(Response?.category_icon)
                                            }
                                        } else {
                                            formik.resetForm();
                                            setProfilePicture('');
                                            setFileName('');
                                        }
                                    }}
                                    sx={{ mt: 3, mb: 2 }}
                                >
                                    Cancel
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    sx={{ mt: 3, mb: 2, background: `${GLOBAL_CONSTANTS.COLOR_CODE.GRADIENT}` }}
                                >
                                    Submit
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                )}
            </Formik>

        </>
    )
}

export default CreateDepartment;